import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import { TranslocoService, translate } from '@jsverse/transloco';

import { Subscription } from 'rxjs';

import { ActionPlanConstants } from 'app/constants/constants';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

interface StatusInfo {
  id: 'NEW' | 'IN_PROGRESS' | 'COMPLETED';
  text: string;
  color: string;
}

@EnableClassTelemetry()
@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss'],
  standalone: false,
})
export class StatusLabelComponent implements OnInit, OnChanges, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() status: string;
  @Input() isFixed: boolean;

  @Output() statusChange: EventEmitter<string> = new EventEmitter<string>();

  protected statuses: StatusInfo[] = [
    {
      id: 'NEW',
      text: translate('action-plan-status-label-component.not-started'),
      color: ActionPlanConstants.NOT_STARTED_COLOR,
    },
    {
      id: 'IN_PROGRESS',
      text: translate('action-plan-status-label-component.in-progress'),
      color: ActionPlanConstants.IN_PROGRESS_COLOR,
    },
    {
      id: 'COMPLETED',
      text: translate('action-plan-status-label-component.completed'),
      color: ActionPlanConstants.COMPLETED_COLOR,
    },
  ];

  text: string;
  color: string;
  private translationSubscription: Subscription;
  constructor(private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.setAttributes();
    this.translationSubscription = this.translocoService
      .selectTranslateObject('action-plan-status-label-component')
      .subscribe((translatedValue) => {
        this.statuses.forEach((element) => {
          switch (element.id) {
            case 'NEW':
              element.text = translatedValue['not-started'];
              break;
            case 'IN_PROGRESS':
              element.text = translatedValue['in-progress'];
              break;
            case 'COMPLETED':
              element.text = translatedValue['completed'];
              break;
            default:
              break;
          }
        });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.status && !changes.status.firstChange) {
      this.setAttributes();
    }
  }

  ngOnDestroy(): void {
    this.translationSubscription?.unsubscribe();
  }

  onStatusChange(status: 'NEW' | 'IN_PROGRESS' | 'COMPLETED'): void {
    this.statusChange.emit(status);

    this.setAttributes();
  }

  private setAttributes(): void {
    const statusInfo = this.statuses.find((s) => s.id === this.status);

    this.text = statusInfo.text;
    this.color = statusInfo.color;
  }
}
